/**
 * Visual overlay shown when the user is dragging valid files over a chat
 * surface. Used by both <FarChatPopup /> and <HomeChatPanel />. Pure
 * presentational — drag state lives in the `useDragDropUpload` hook.
 */
import React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useChatFeedbackLock } from './ChatFeedbackOverlays';

interface Props {
  visible: boolean;
}

const DropOverlay: React.FC<Props> = ({ visible }) => {
  const locked = useChatFeedbackLock();
  if (!visible || locked) return null;
  return (
    <Box
      data-testid="drop-overlay"
      role="presentation"
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: (theme) => alpha(theme.palette.background.paper, 0.85),
        border: '2px dashed',
        borderColor: 'primary.main',
        borderRadius: 2,
        pointerEvents: 'none',
      }}
    >
      <Typography variant="subtitle1" sx={{ color: 'text.primary', fontWeight: 600 }}>
        Drop PDF, PNG, or JPEG to attach
      </Typography>
    </Box>
  );
};

export default DropOverlay;
